// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3S3lN","controls":"styles_controls__3aigP","charLimit":"styles_charLimit__3ueOn","input":"styles_input__1XzvE","send":"styles_send__1PjXn"};